// ScrollIndicator.tsx
import React from 'react';

import styled from 'styled-components';

const ScrollIndicatorWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    bottom: 0;
    left: 0;
    // position: absolute;
    width: fit-content;
    /* Ensure it doesn't scroll with the content */
    flex-shrink: 0;
    margin-bottom: 30px;
  }
`;

const PageText = styled.div`
  font-size: 14px;
  width: 60px;
  transform-y: 15px;
  color: #706d69;
  text-align: right;
`;

interface ScrollIndicatorProps {
  currentIndex: number;
  totalCount: number;
}

// Inactive pages are dots and the current page is a pill PILL_EXTRA_WIDTH wider, spaced one dot apart
const DOT_SIZE = 6;
const DOT_STEP = DOT_SIZE * 2;
const PILL_EXTRA_WIDTH = 20;

const ScrollIndicator: React.FC<ScrollIndicatorProps> = ({ currentIndex, totalCount }) => {
  const width = DOT_STEP * (totalCount - 1) + DOT_SIZE + PILL_EXTRA_WIDTH;
  const radius = DOT_SIZE / 2;

  return (
    <ScrollIndicatorWrapper>
      <svg
        width={width}
        height={DOT_SIZE + 1}
        viewBox={`0 0 ${width} ${DOT_SIZE + 1}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {Array.from({ length: totalCount }, (_, index) => {
          const centreX = index * DOT_STEP + radius + (index > currentIndex ? PILL_EXTRA_WIDTH : 0);
          const centreY = radius + 0.5;

          return index === currentIndex ? (
            <path
              key={index}
              d={`M${centreX} ${centreY}h${PILL_EXTRA_WIDTH}`}
              stroke="var(--stile-green-3)"
              strokeWidth={DOT_SIZE}
              strokeLinecap="round"
            />
          ) : (
            <circle key={index} cx={centreX} cy={centreY} r={radius} fill="var(--stile-grey-5)" />
          );
        })}
      </svg>
      <PageText>
        {currentIndex + 1} of {totalCount}
      </PageText>
    </ScrollIndicatorWrapper>
  );
};

export default ScrollIndicator;
